import React, { createContext, useState } from 'react'
import box1 from '../assets/boxes/carton-fruitibox.png'

export const CartContext = createContext();

const CartContextProvider = props => {
    const [ cart, setCart ] = useState([]);
    const [ quantity, setQuantity ] = useState(0);
    const [ total, setTotal ] = useState(0)
    const [ transport, setTransport ] = useState("bateau");

    
    const [ box, setBox ] = useState({
        id: 1,
        img: box1,
        nom: "Fruitibox"
    });

    const addToCart = item => {
        const newCart = [...cart];
        newCart.push(item);
        setCart(newCart);

        let tp = total + item.total_price;
        setTotal(tp);
        let qtt = quantity + 1;
        setQuantity(qtt);
    }

    const editCart = (id, data) => {
        let editedCart = [...cart]; // COPIER LE PAMIER

        // CHERCHER LA POSITION DE L'ELEMENT A MODIFIER
        const i = editedCart.findIndex(item => item.mango_id == id);
        // console.log("prev: "+total);

        // MODIFICATIONS
        editedCart[i] = {
            ...editedCart,
            caiibre: data.calibre,
            quantity: data.quantity,
            total_price: parseInt(data.quantity)*2.5
        }
        
        setCart(editedCart);

        // METTRE A JOUR LE PRIX TOTAL
        let updatedTotal = 0;
        cart.forEach(item => updatedTotal += parseInt(item.total_price)); 
        setTotal(updatedTotal);
    }
  
    return (
        <CartContext.Provider
            value={{
                cart, quantity,
                total, addToCart,
                transport, setTransport,
                box, setBox,
                editCart
            }}
        >
            {props.children}
        </CartContext.Provider>
    )
}

export default CartContextProvider